import React from 'react';
import useTranslations from '@hooks/useTranslations';
import Icon, { Icons } from '@components/Icon';
import { isBrandAC } from 'src/constants/main';
import { useSelector } from 'react-redux';
import { CarJourneyType } from 'src/services/carList/carList.types';
import GlobalDuck from 'src/redux/global/global.duck';
import { GtmData } from 'src/types/gtm';
import { useGTM } from '@hooks/useGTM';
import { getFAQsURL } from './helper';
import { IGlobalState } from 'src/redux/redux.interface';

export interface INeedHelpSectionProps {
    phoneNumber: string;
}

interface IProps extends INeedHelpSectionProps {
    className?: string;
}

const NeedHelpSection = ({ className, phoneNumber }: IProps) => {
    const { t } = useTranslations();
    const carJourney = useSelector<IGlobalState, CarJourneyType>((state) => GlobalDuck.getCarJourney(state));
    const { pushToDataLayer } = useGTM();

    return (
        <div className={className} data-testid="need-help-section">
            <div className="need-help-section__contact">
                <p className="need-help-section__title">{t('header.nav.needHelp')}</p>
                <p className="need-help-section__title">{t('header.nav.callUs')}</p>
                <a className="need-help-section__link need-help-section__phone" href={`tel:${phoneNumber.trim()}`}>
                    {phoneNumber}
                </a>
                <p className="need-help-section__text need-help-section__call-text">{t('header.nav.callUsTime')}</p>
                <p className="need-help-section__text need-help-section__call-text">
                    {t('header.nav.callFreeOfCharge')}
                </p>
            </div>

            <div className="need-help-section__faq">
                <p className="need-help-section__title">{t('header.nav.anyQuestions')}</p>
                <p className="need-help-section__title">{t('header.nav.checkFAQ')}</p>
                <a
                    href={getFAQsURL(carJourney)}
                    className="need-help-section__link need-help-section__faq"
                    onClick={() =>
                        pushToDataLayer({
                            event: 'uaevent',
                            eventCategory: 'Header',
                            eventAction: `Redirection::Internal`,
                            eventLabel: 'Most common questions',
                        } as GtmData)
                    }
                >
                    <span>{t('header.nav.FAQLink')}</span>
                    {!isBrandAC && (
                        <Icon height={10} name={Icons.ChevronRight} className="need-help-section__link__icon" />
                    )}
                </a>
            </div>
            <span className="need-help-section__closeIcon">
                <Icon height={10} name={Icons.Cancel} className="need-help-section__chevron" />
            </span>
        </div>
    );
};

export default NeedHelpSection;
